import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import ProcessExtractResult from '@pages/candidate/userinput/ProcessExtractResult';
import {cloneDeep} from 'lodash';

const ProcessExtractResultModal = (props) => {
    const [candidates, setCandidates] = useState([]);
    const [fullscreen, setFullscreen] = useState(true);
    const {extractResults} = props
    const {isShow} = props
    const {onClose} = props

    // useEffect(() => {
    //     setCandidates(cloneDeep(extractResults));
    // },[candidates]);

    return (
        <>
            <Modal show={isShow}
                   fullscreen={fullscreen}
                   dialogClassName='modal-90w'
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Xử lý kết quả bóc tách</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    {extractResults && extractResults.length > 0 &&
                    <ProcessExtractResult
                        isShow={extractResults.length > 0}
                        candidateList={extractResults}
                        cvFailedList={[]}
                        isExportExcel={false}
                        hasInputCommon={false}
                    />
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ProcessExtractResultModal;
